import { render, staticRenderFns } from "./workspace-sidebar-right-item.vue?vue&type=template&id=add3ffc8&scoped=true&"
import script from "./workspace-sidebar-right-item.vue?vue&type=script&lang=js&"
export * from "./workspace-sidebar-right-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add3ffc8",
  null
  
)

export default component.exports